import { Enum, Selectable } from './Enum';

export class PatientGuideRelationship extends Enum {
  translationKey = 'patientGuideRelationship';

  static asArray: PatientGuideRelationship[] = [];

  static byKey: { [name: string]: PatientGuideRelationship } = {};

  static readonly SPOUSE = new PatientGuideRelationship('SPOUSE');

  static readonly DOMESTIC_PARTNER = new PatientGuideRelationship(
    'DOMESTIC_PARTNER',
  );

  static readonly DAUGHTER = new PatientGuideRelationship('DAUGHTER');

  static readonly SON = new PatientGuideRelationship('SON');

  static readonly SIBLING = new PatientGuideRelationship('SIBLING');

  static readonly OTHER_FAMILY_MEMBER = new PatientGuideRelationship(
    'OTHER_FAMILY',
  );

  static readonly FRIEND = new PatientGuideRelationship('FRIEND');

  static readonly OTHER_NON_FAMILY = new PatientGuideRelationship(
    'OTHER_NON_FAMILY',
  );

  static toSelectable() {
    return Enum.toSelectable(Object.values(PatientGuideRelationship.byKey));
  }

  static getRelationshipFromString(
    relationshipString?: string,
  ): Selectable | undefined {
    if (!relationshipString) return undefined;
    return PatientGuideRelationship.toSelectable().find(
      (option) => option.value === relationshipString,
    );
  }

  constructor(public readonly value: string) {
    super();
    PatientGuideRelationship.asArray.push(this);
    PatientGuideRelationship.byKey[value] = this;
  }
}

export default PatientGuideRelationship;
